
import ReadyToTalkWithVideo from '~/components/page-components/ReadyToTalkWithVideo.vue';
import ServiceIntro from '~/components/page-components/servicepage/ServiceIntro.vue';
import DesktopServiceBar from '~/components/page-components/servicepage/ServiceBar/DesktopServiceBar.vue';
import ServiceBar from '~/components/page-components/servicepage/ServiceBar/ServiceBar.vue';

export default {
  components: { ServiceIntro, DesktopServiceBar, ReadyToTalkWithVideo, ServiceBar },
  mounted () {
    this.$store.commit('closeMenu');
  }
};
